import { useFela } from 'react-fela';

import { Modal } from '@/modules/modals';

import { useTrialModal } from '../../hooks';
import { TrialEndContent } from './TrialEndContent';
import * as felaRules from './TrialModal.rules';
import { TrialStartContent } from './TrialStartContent';

export const TrialModal = () => {
    const { css } = useFela();
    const { modal } = useTrialModal();

    return (
        <Modal open={modal?.visibility} width='32.5rem' zIndex={2000} extend={{ container: felaRules.modalContainer }}>
            <div className={css(felaRules.contentContainer)}>
                {modal?.data?.type === 'start' ? <TrialStartContent /> : <TrialEndContent />}
            </div>
        </Modal>
    );
};
